export default function DOM_NodeInfo() {
  return (
    <div>
      <h1>DOM_NodeInfo</h1>
      <p>This is the DOM_NodeInfo component.</p>
    </div>
  );
}